import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isEcomPhone(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.ECOM_PHONE && typeof label === 'string' && typeof value === 'string';
}
function _formatEcomPhone(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatEcomPhone(submission) {
  if (isEcomPhone(submission)) {
    return _formatEcomPhone(submission);
  }
  return undefined;
}
//# sourceMappingURL=ecom-phone-preview.js.map